import { Component, OnInit } from '@angular/core';


import {homeComponentService} from '../services/app.services'
import{IContact,IAboutUs} from '../model/app.model'

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {
    
    contact : IContact
    about:IAboutUs
    
    model = {
        left: true,
        middle: false,
        right: false
    };


    constructor(private homeService: homeComponentService) {

    
  }

    ngOnInit() {

        
        this.homeService.getContact().subscribe(contact => {
        this.contact = contact;


        })

        this.homeService.getAboutUs().subscribe(about => {
        this.about = about;


        })


  }
    
}



// WEBPACK FOOTER //
// /apps/dev/flashqubes/src/app/home/home.component.ts